import type { DocumentReference, Timestamp } from 'firebase/firestore'
import { collection, query, where } from 'firebase/firestore'
import { firestore } from '~/firebaseCore'

export const collectionDocuments = collection(
  firestore,
  'documents',
)

export function documentsQuery(companyRef: DocumentReference, dateFrom: Timestamp, dateTo: Timestamp, userRef?: DocumentReference) {
  if (userRef) {
    return query(
      collectionDocuments,
      where('company', '==', companyRef),
      where('expireTime', '>=', dateFrom),
      where('expireTime', '<=', dateTo),
      where('visibilityAccess', 'array-contains', userRef),
    )
  }

  return query(
    collectionDocuments,
    where('company', '==', companyRef),
    where('expireTime', '>=', dateFrom),
    where('expireTime', '<=', dateTo),
  )
}
